import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { Clock, CheckCircle, AlertCircle, Upload } from "lucide-react";
import { RenderJobStatus } from "../../../shared/schema";

interface RenderStatusBadgeProps {
  status: RenderJobStatus;
  className?: string;
}

export function RenderStatusBadge({ status, className }: RenderStatusBadgeProps) {
  const getStatusConfig = (status: RenderJobStatus) => {
    switch (status) {
      case RenderJobStatus.QUEUED:
        return {
          label: 'Queued',
          variant: 'outline' as const,
          icon: <Clock className="h-3 w-3 mr-1" />,
          className: 'text-yellow-800 border-yellow-200 bg-yellow-100'
        };
      case RenderJobStatus.RENDERING:
        return {
          label: 'Rendering',
          variant: 'outline' as const,
          icon: <Clock className="h-3 w-3 mr-1 animate-spin" />,
          className: 'text-yellow-800 border-yellow-200 bg-yellow-100'
        };
      case RenderJobStatus.COMPLETE:
        return {
          label: 'Complete',
          variant: 'outline' as const,
          icon: <CheckCircle className="h-3 w-3 mr-1" />,
          className: 'text-green-800 border-green-200 bg-green-100'
        };
      case RenderJobStatus.FAILED:
        return {
          label: 'Failed',
          variant: 'outline' as const,
          icon: <AlertCircle className="h-3 w-3 mr-1" />,
          className: 'text-red-800 border-red-200 bg-red-100'
        };
      case RenderJobStatus.UPLOADING:
        return {
          label: 'Uploading',
          variant: 'outline' as const,
          icon: <Upload className="h-3 w-3 mr-1 animate-pulse" />,
          className: 'text-blue-800 border-blue-200 bg-blue-100'
        };
      default:
        return {
          label: status,
          variant: 'outline' as const,
          icon: null,
          className: ''
        };
    }
  };
  
  const config = getStatusConfig(status);
  
  return (
    <Badge 
      variant={config.variant} 
      className={cn("flex items-center capitalize px-2 py-0.5 text-xs", 
        config.className, 
        className
      )}
    >
      {config.icon}
      {config.label}
    </Badge>
  );
}
